import { render, staticRenderFns } from "./program-type-display.vue?vue&type=template&id=85dbed26&scoped=true&"
import script from "./program-type-display.vue?vue&type=script&lang=ts&"
export * from "./program-type-display.vue?vue&type=script&lang=ts&"
import style0 from "./program-type-display.vue?vue&type=style&index=0&id=85dbed26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85dbed26",
  null
  
)

export default component.exports